import { usePrice } from "../TileKit/hooks";

interface CashDownWithTradeOptions {
    isNegativeEquity: boolean;
    tradeDown: number;
    downPayment: number;
    minDownPaymentNoTradeIn: number;
}

interface TermsCashDown extends CashDownWithTradeOptions {
    hasTradeIn: boolean;
    filterDownPayment: number;
}

export const formatPrice = (price: number): string => Number(price).toLocaleString();

export const getTermsCashDownWithTrade = ({
    isNegativeEquity,
    tradeDown = 0,
    downPayment = 0,
    minDownPaymentNoTradeIn = 0
}: CashDownWithTradeOptions): number => {
    const maybeAddMinDown = tradeDown > minDownPaymentNoTradeIn ? 0 : minDownPaymentNoTradeIn;
    const positiveEquityCashDown = downPayment - (Math.max(tradeDown, 0) + maybeAddMinDown)
    const negativeEquityWithMinDown = Math.abs(tradeDown) + minDownPaymentNoTradeIn;
    return isNegativeEquity ? Math.max(downPayment, negativeEquityWithMinDown, 0) : positiveEquityCashDown;
}

const getTermsCashDownNoTrade = ({
    isNegativeEquity,
    tradeDown = 0,
    downPayment = 0,
    minDownPaymentNoTradeIn = 0,
    filterDownPayment = 0
}) => {
    const downPaymentNoTrade = downPayment - tradeDown;
    const cashDownNoTrade = Math.max(filterDownPayment, downPaymentNoTrade, minDownPaymentNoTradeIn, 0);
    return isNegativeEquity ? Math.max(minDownPaymentNoTradeIn, filterDownPayment) : cashDownNoTrade
}

export const getTermsCashDown = ({
    hasTradeIn,
    ...rest
}: TermsCashDown): string => {
    const cashDown = hasTradeIn
        ? getTermsCashDownWithTrade({ ...rest })
        : getTermsCashDownNoTrade({ ...rest })
    return formatPrice(Math.max(cashDown, 0));
}

export const useTotalPrice = (): number => {
    const price = usePrice();
    return price?.total || 0;
};